import React, { useState, useEffect, useMemo } from 'react';
import { supabase } from '../config/supabase';

const FilesSidebar = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Memoize the knownFiles array
  const knownFiles = useMemo(() => [
    'BILLS-113hr3204enr.pdf',
    'epcis-cbv 2.0.pdf',
    'GS1_DataMatrix_Guideline.pdf',
    'GS1US DSCSA Barcode Assessment Summary wp_FINAL3.pdf',
    'LOT-Special Characters.pdf'
  ], []); // Empty dependency array since this array never changes

  useEffect(() => {
    async function fetchFiles() {
      try {
        console.log('Environment check:', {
          url: process.env.REACT_APP_SUPABASE_URL,
          keyExists: !!process.env.REACT_APP_SUPABASE_KEY
        });

        // Verify each file exists
        const fileChecks = await Promise.all(
          knownFiles.map(async (filename) => {
            const { data, error } = await supabase
              .storage
              .from('Public')
              .download(`assistant_files/${filename}`);
            
            return {
              name: filename,
              exists: !!data && !error
            };
          })
        );

        const existingFiles = fileChecks
          .filter(file => file.exists)
          .map(file => ({ name: file.name }));

        console.log('Verified files:', existingFiles);
        setFiles(existingFiles);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching files:', err);
        setError(err.message);
        setLoading(false);
      }
    }

    fetchFiles();
  }, [knownFiles]); // Now it's safe to include knownFiles in the dependency array

  const formatFileName = (name) => {
    // Remove .pdf extension
    const withoutExtension = name.replace('.pdf', '');
    // Add spaces around hyphens and underscores
    return withoutExtension
      .replace(/-/g, ' - ')
      .replace(/_/g, ' ');
  };

  if (loading) {
    return <div className="p-4">Loading files...</div>;
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="text-red-500">Error loading files: {error}</div>
        <div className="text-sm text-gray-500 mt-2">
          Check browser console for details
        </div>
      </div>
    );
  }

  return (
    <div className="w-64 h-full bg-gray-50 dark:bg-gray-800 border-r dark:border-gray-700 p-4">
      <h2 className="text-xl font-semibold mb-6 text-gray-900 dark:text-gray-100">
        Files ({files.length})
      </h2>
      <div className="space-y-3">
        {files.length === 0 ? (
          <div className="text-gray-500">No files found in bucket</div>
        ) : (
          files.map((file) => (
            <div 
              key={file.name}
              onClick={() => window.open(`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/Public/assistant_files/${file.name}`, '_blank')}
              className="group p-3 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors duration-150 ease-in-out"
            >
              <span className="text-sm text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 leading-tight">
                {formatFileName(file.name)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FilesSidebar; 